module.exports = __webpack_public_path__ + "img/convocatoriaJunio2022.142277be.jpg";